export let AllRatings = [
    {
        name: "Un amigo muy extraño",
        stars: 5,
        review: `Umm no sé cómo empezar esto la verdad, quizás desde el comienzo ¿Sabías que, literalmente, el primer stream que vi y que realmente me intereso, fue el tuyo? Era muy divertido y muy sincero principalmente eso, además de ser muy auténtico, y sentir afinidad contigo (no homo) afinidad de hermano, no tengo ni idea si sentiste lo mismo conmigo, pero te quiero mucho hermano, nos hemos contado mutuamente cosas personales y problemas con la intención de que el otro nos escuche y que además nos diera consejos o una orientación, fuiste quien… sin saberlo me motivo hacer stream, eres alguien a quien sin conocer en persona, siento que disfrutaríamos mucho saliendo y jugando en personas, eres una persona increíble nunca cambies mi hermano, eres una persona muy auténtica y te felicito como has superado, todas las adversidades a las que has enfrentado en EEUU, sé que no ha sido fácil, mereces un feliz cumpleaños increíble, tal como la persona que eres …<br/> <br/>
			Posdata: gracias por ayudarme el día que de verdad necesitaba ayuda. 
			<br/> <br/>		
			Como decías en tus primeros directos (Corazón Koreano para ti)`,
    },
    {
        name: "WayraisBleu",
        stars: 5,
        review: `Felizmente me encontré con este programador y me pareció una persona muy amable y atenta, por lo que me casé con él.
		<br> </br>
		tata te quiero`,
    },
    {
        name: "CarlosMushuTV",
        stars: 1,
        review: "Intento aprender de su contenido pero me es imposible por que me hornea demasiado verlo.",
    },
    {
        name: "WilmiRosa",
        stars: 5,
        review: "Tcela es el mejor programador de UwU!",
    },
    {
        name: "PodcastMataró",
        stars: 5,
        review: "Tata tenía tanto talento, que tecleo'sta obtener a twayra, y también tomó a taro en su aposento. Taro tuvo una vida contento, junto a tblue tuvieron un entierro, y con pato en el centro.",
    },
    {
        name: "Cornelio",
        stars: 5,
        review: "Él si era",
    },
    {
        name: "Solecitotecalientaunpoquito",
        stars: 5,
        review: "Espero que tengas un lindo día, quizás no pueda felicitarte o comunicarme contigo, pero que sepas que estaré deseándote lo mejor y espero el mejor momento que puedas pasar en tu cumpleaños.",
    },
    {
        name: "Chicken",
        stars: 5,
        review: "Conoci a teclas cuando un dia entre a su canal porque era acerca de programacion… estaba cantando asi que obvio me quede a ver que mas hacia xp. La verdad si me sorprendi un poco en que empazaba a decir “les cuento un chisme? Les cuando un chisme?” Pues ya no cabe mencionar que me di cuenta que su canal era mas de chisme que de programacion… y como usualmente dejo la programacion abandonada(pero el chisme no) pues por eso me quede. Le pone mas esfuerzo a los trolls, pero tmb es buen programador y aun mejor amigo.",
    },
    {
        name: "Follow 4 Follow",
        stars: 2,
        review: "Mira éste <a target='_blank' href='https://www.youtube.com/watch?v=dQw4w9WgXcQ'>video</a>",
    },
    {
        name: "Gustave Jev",
        stars: 5,
        review: `Tcela pedazo de desgraciao, te quiero decir que me descolocás porque sos un man que con hablar conmigo mientras hacías lo que yo creo es tu pasíón, hiciste que te admire a lo desgraciao, sos para mí un modelo a seguir y te admiro como programador, como streamer y como persona con lo que hasta ahora conozco de vos. Me parecés un tipazo y estoy contento con el momento en que entré a las categorías de Twich y elegí tu stream, donde me diste ánimos desde la primera aplicación que desarrollé y me dijiste que era recién el comienzo de lo que podía hacer... o algo así me dijiste xd... Efectivamente tenías razón.
		Vos y la masturbanda de programadores son unas de las personas que; si volviera al pasado, me gustaría volver a conocer una y otra vez. <br></br>
		<br></br>
		PD: Aguante Boca!`
    },
    {
        name: "Maria ElzapoRico <3",
        stars: 3,
        review: `Por días de más programación y menos chisme :) `
    },
];
